import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import { GoogleAnalyticsService } from './services/monitoring/googleAnalyticsService';
import './styles/normalize.scss';
GoogleAnalyticsService.initialize();
ReactDOM.render(<App />, document.getElementById('root'));
